import { ref } from 'vue';
import axios from 'axios';

const sessionComplexes = ref([]);
const sessionComplexNames = ref([]);

export default function useSession() {
  const fetchSessionComplexes = async (sessionId) => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/sessionComplexes/`, {
        params: {
          sessionId,
        },
      });
      sessionComplexes.value = response.data.data;
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSessionComplexNames = async (sessionId) => {
    await fetchSessionComplexes(sessionId);
    const result = sessionComplexes.value.map((x) => x.name);
    sessionComplexNames.value = result;

    return result;
  };

  return {
    fetchSessionComplexes,
    fetchSessionComplexNames,
    sessionComplexes,
    sessionComplexNames,
  };
}
